import React from "react";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

const Contact = () => {
  return (
    <section className="bg-gray-50 min-h-screen">
      {/* Page Top */}
      <div className="page-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="page-title">Contact</h1>
              <h2 className="page-description">Gemstone Real Estate Ltd.</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 mt-6">
        {/* Contact Info Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow text-center">
            <FaEnvelope className="text-blue-600 text-3xl mx-auto mb-4" />
            <h5 className="font-semibold text-lg mb-1">Email</h5>
            <p className="text-gray-600">gemstonereltd@gmail.com</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow text-center">
            <FaMapMarkerAlt className="text-blue-600 text-3xl mx-auto mb-4" />
            <h5 className="font-semibold text-lg mb-1">Address</h5>
            <p className="text-gray-600">
              Nest Osmium Tower (4th Floor), 1/1, Satmasjid Road, Block-E,
              Mohammadpur Housing Estate, Dhaka-1207
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow text-center">
            <FaPhoneAlt className="text-blue-600 text-3xl mx-auto mb-4" />
            <h5 className="font-semibold text-lg mb-1">Phone</h5>
            <p className="text-gray-600">
              01776-767687 <br /> 01776-767685 <br /> 01776-767609
            </p>
          </div>
        </div>

        {/* Google Map */}
        <div className="rounded-xl overflow-hidden shadow-lg mb-6">
          <div className="w-full h-96 md:h-[450px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.7378552604773!2d90.35965937430964!3d23.756725788535405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755bf36344ebe2d%3A0xa6adb75ab7515bea!2sNest%20Osmium!5e0!3m2!1sen!2sbd!4v1761476760278!5m2!1sen!2sbd"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Gemstone Real Estate Map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
